import React from 'react';
import Icon from './icon';
import { IconProps } from './types';

const ICON_PATH = 'M14 8L12.9425 9.0575L17.1275 13.25H8V14.75H17.1275L12.9425 18.9425L14 20L20 14L14 8Z';

export const ArrowForwardIcon: React.FC<IconProps> = ({ size, color }) => {
	return <Icon path={ICON_PATH} size={size} color={color} />;
};
